import { Zap } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ZapIcon = createLucideIcon(Zap);
